import { signOut } from "firebase/auth";
import { auth } from "lib/firebase/firebase";
import { UserAuth } from "provider/AuthProvider";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./admin.css";
import AdminSidebar from "customComponents/AdminComponents/AdminSidebar";
import { tokenResult } from "lib/utilities/tokenResult";
import { BASE_URL } from "lib/utilities/globalConstants";
import Loader from "customComponents/Loader";
function AdminLayout({ component, loadFullLayout = true }) {
  const splitPath = window.location.pathname.split("/");
  const isTechyrrRoute = splitPath[1] === "techyrr";
  const [isLoading, setIsLoading] = useState(true);
  const {
    user,
    initializing,
    authorized,
    setWallet,
    setExperiencePrice,
    setCoinPrice,
    setSkillPrice,
  } = UserAuth();
  const params = new URLSearchParams(window.location.search);
  const inviteId = params.get("inviteId");
  const companyId = params.get("companyId");

  const navigate = useNavigate();

  async function getAdminCoinWallet() {
    try {
      const res = await fetch(`${BASE_URL}admin/getAdminCoinWallet`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${(await tokenResult(user)).token}`,
        },
      });
      const { data } = await res.json();
      setWallet({ Coins: data?.numberOfCoins, Hold: data?.coins_hold, Spent: data?.coins_spent });
      setExperiencePrice(data?.experience_pricing);
      setCoinPrice(data?.coin_price);
      setSkillPrice(data?.skill_price);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (initializing) return;
    if (isTechyrrRoute && !user) return setIsLoading(false);
    if (!user) {
      if (inviteId) {
        if (companyId) {
          navigate(`/admin/signup/${inviteId}?companyId=${companyId}`);
        } else {
          navigate(`/admin/signup/${inviteId}`);
        }
      } else navigate("/signin");
      return;
    }
    if (user && authorized) {
      getAdminCoinWallet();
    }
  }, [user, initializing, authorized]);

  if (isLoading) return <Loader />;

  return (
    <>
      {(user?.claims?.admin && authorized) || isTechyrrRoute ? (
        loadFullLayout ? (
          <div className="h-dvh flex z-0"> 
            <div className="bg-white flex flex-1 flex-row" >
              <AdminSidebar />
              <div className="flex flex-1 flex-col overflow-auto">{component}</div>
            </div>
          </div>
        ) : (
            <div className="min-h-dvh flex">{component}</div>
        )
      ) : (
          <div className="h-dvh flex w-full">
            <div className="unauthorized-container w-full">
              <h2 className="unauthorized-heading">You are not authorized.</h2>
              <button
                className="logout-button"
                onClick={async () => {
                  await signOut(auth);
                  navigate("/signin");
                }}
              >
                Logout
              </button>
            </div>
          </div>
      )}
    </>
  );
}

export default AdminLayout;
